//  vue 初始化
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { globalRegister } from './global'

// 样式初始化
import 'normalize.css'
import '../src/assets/css/index.less'

import { setupStore } from './store'
const app = createApp(App)

// 注册element-plus/其他
app.use(globalRegister)
app.use(store)
setupStore()
app.use(router)
app.mount('#app')
